/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  DeleteGrantMutationResponse,
  DeleteGrantPathParams,
  DeleteGrant403,
  DeleteGrant404,
  DeleteGrant500,
} from '../types/DeleteGrant'

function getDeleteGrantUrl({
  grant_id,
}: {
  grant_id: DeleteGrantPathParams['grant_id']
}) {
  const res = {
    method: 'DELETE',
    url: `/api/v1/nylas/grants/${grant_id}/` as const,
  }
  return res
}

/**
 * @summary Delete a grant and revoke its Nylas integrations
 * {@link /api/v1/nylas/grants/:grant_id/}
 */
export async function deleteGrant(
  { grant_id }: { grant_id: DeleteGrantPathParams['grant_id'] },
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    DeleteGrantMutationResponse,
    ResponseErrorConfig<DeleteGrant403 | DeleteGrant404 | DeleteGrant500>,
    unknown
  >({
    method: 'DELETE',
    url: getDeleteGrantUrl({ grant_id }).url.toString(),
    ...requestConfig,
  })
  return res.data
}
